import { assetsBaseUrl, riskBaseUrl } from '@Apis';

import { useFilter } from '@innovyze/inno-map';
import { useIsFeatureEnabled } from '@innovyze/stylovyze';

export const useDatagridFilter = () => {
	const isDatagridFilterEnabled = !!useIsFeatureEnabled(
		'i-360-release-139225-apply-data-grid-filter-on-map',
	);
	const isSpatialFilterEnabled = !!useIsFeatureEnabled(
		'i-360-release-146545-add-filter-to-spatial-data-in-data-grid',
	);
	const { filter, additionalFilterProps, excludedFilter, filterCount } =
		useFilter();

	const filterEndpoints = [
		{
			endpoint: `${assetsBaseUrl}/assets/filtered-status`,
			dataType: 'all',
		},
		...(isSpatialFilterEnabled
			? [
					{
						endpoint: `${riskBaseUrl}/spatial/layer/{layerName}?filteredStatus=true`,
						dataType: 'SpatialData',
					},
			  ]
			: []),
	];

	return {
		isDatagridFilterEnabled,
		datagridFilter: isDatagridFilterEnabled
			? { ...filter, ...additionalFilterProps, exclude: excludedFilter }
			: undefined,
		datagridFilterEndpoints: isDatagridFilterEnabled
			? filterEndpoints
			: undefined,
		dataGridFilterCount: isDatagridFilterEnabled ? filterCount : undefined,
	};
};
